export function FoundationMenuJS() {
	'use strict';

	var consts = {
		MOBILE_THRESHOLD_PX: 1024,

		ANIMATION_DELAY: 50,

		ANIMATION_SPEED: 400,
	};

	$(function () {
		/**

       * Store the scroll top position as applying overflow:hidden to the body makes it jump to 0

       * @type int

       */

		var scrollTop;

		$('.bark-menu-main-toggle-mob')
			.unbind('click.openmenu')
			.on('click.openmenu', function (e) {
				e.stopPropagation();

				if ($(this).closest('.bark-mob-open').length) {
					// The mobile menu is already open

					return;
				}

				var t = $(this);

				var interval;

				t.addClass('bark-mob-open');

				$('nav.top-bar.dont-hide').addClass('barkmenuopen');

				$('#header .default-top-head').addClass('barkmenuopen');

				$('.bark-mob-menu-items').scrollTop(0);

				$('ul.bark-mob-menu-items .main li').each(function (index) {
					$(this)
						.finish()
						.delay(consts.ANIMATION_DELAY * index)
						.animate({ opacity: 1, top: 0, left: 0 }, consts.ANIMATION_SPEED, 'swing');
				});

				interval = window.setTimeout(function () {
					// Corrective fix: W3C says that animations cannot start from display: none, so wait a decent amount of time before switching it on

					$('.bark-menu-avatar').addClass('menu-open');
				}, 10);

				scrollTop = $('body').scrollTop() || $('html').scrollTop();

				$('body,html').css({ overflow: 'hidden' });

				$(window)
					.unbind('resize.closeMenu')
					.on('resize.closeMenu', function () {
						if ($(this).width() >= consts.MOBILE_THRESHOLD_PX) {
							$('.bark-menu-hamburger').click();
						}
					});
			});

		$('.bark-menu-hamburger')
			.unbind('click.closemenu')
			.on('click.closemenu', function (e) {
				var t = $(this);

				var container = t.closest('.bark-mob-open');

				if (!container.length) {
					// The mobile menu isn't open yet

					return;
				}

				e.stopPropagation();

				container.removeClass('bark-mob-open');

				$('ul.bark-mob-menu-items .main li').each(function (index) {
					$(this)
						.finish()
						.delay(consts.ANIMATION_DELAY * index)
						.animate(
							{ opacity: 0, top: '20px', left: '20px' },
							consts.ANIMATION_SPEED,
							'swing',
						);
				});

				$('.bark-mob-menu-items').removeClass('show-notifications');

				$('.bark-mob-menu-items ul').scrollTop(0);

				t.closest('.barkmenuopen').removeClass('barkmenuopen');

				$('#header .default-top-head').removeClass('barkmenuopen');

				$('.bark-menu-avatar.menu-open').removeClass('menu-open');

				$('body,html').css({ overflow: 'initial' }).scrollTop(scrollTop);

				$(window).unbind('resize.closeMenu');
			});

		$('.notification-count-container')
			.unbind('click.opennots')
			.on('click.opennots', function () {
				// Open the notifications pane

				$('.bark-mob-menu-items').addClass('show-notifications').scrollTop(0);
			});

		$('.bark-mob-menu-items .back')
			.unbind('click.showmenu')
			.on('click.showmenu', function () {
				// Hide the notifications pane

				$('.bark-mob-menu-items').removeClass('show-notifications').scrollTop(0);
			});
	});
}
